import { render } from "./ClientInfoBlock.vue?vue&type=template&id=00b89595&scoped=true"
import script from "./ClientInfoBlock.vue?vue&type=script&lang=ts"
export * from "./ClientInfoBlock.vue?vue&type=script&lang=ts"

import "./ClientInfoBlock.vue?vue&type=style&index=0&id=00b89595&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00b89595"

export default script